<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { deviceJudgment } from "@/utils/index.js";
export default {
  name: "App",
  data() {
    return {
      mobile: deviceJudgment(),
    };
  },
  created() {
    const h = this.$createElement;

    this.$notify({
      title: "寺院公告",
      // showClose: false,
      customClass: "notice",
      message: h(
        "i",
        { style: "color: red;font-style: normal;font-size:20px" },
       this.notifycontent
      ),
      duration: 10000,
    });
  },
  computed: {
    notifycontent() {
      if (this.mobile) {
        return '【重要声明:谨防假管账号】详情请打开导航栏点击寺院资讯!'
      } else {
        return '【重要声明:谨防假管账号】详情请点击左侧寺院资讯!!'
      }
    },
  },
};
</script>

<style>
body {
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding-right: 0 !important;
}
.notice {
  font-size: 25px !important;
  .el-notification__group {
    .el-notification__title {
      font-size: 25px !important;
    }
  }
}
</style>
